// @ts-ignore
import Vue from 'vue'
import { createI18n, replaceUrlWithKeyValue } from '@esign/esign-i18n'
import zh from './lang/zh-CN'
import en from './lang/en'

// 默认语言
export const DEFAULT_LOCALE = 'zh-CN'

const messages = {
  'zh-CN': zh,
  'en-US': en,
}

const i18n = createI18n(Vue, {
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  formatFallbackMessages: true,
})

/**
 * 翻译
 */
const translate = (key, ...args) => {
  if (i18n) {
    // @ts-ignore
    return i18n.t(key, ...args)
  }

  return key
}

const getLocale = () => {
  return i18n.locale
}

/** 在url上拼接上lang */
const genUrlLang = (url: string): string => {
  const lang = getLocale()

  return replaceUrlWithKeyValue(url, 'lang', lang)
}

export { i18n, translate as $t, getLocale, genUrlLang }
